import { toast } from "react-toastify";

export default function catchError(err) {
  if (err.response.data.message) {
    toast.error(err.response.data.message);
  } else {
    toast.error('Ups! Něco se nepovedlo, napište nám')
  }
}